<template>
  <div
    v-tooltip="{
      content: translate('saveAsNewView'),
      placement: 'bottom',
    }"
    class="save-filters-button pt"
    @click="saveFiltersAsView"
  >
    <em
      :style="getCustomIconStyle(iconPath('view'))"
      class="h-3 min-w-[12px] flex bg-icon-default"
    />
    <span class="text-sm text-text-default font-medium">
      {{ translate('Save') }}
    </span>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import cloneDeep from 'lodash/cloneDeep';

export default {
  mixins: [customIconsMixin],

  computed: {
    currentBoardId() {
      return this.$store.getters.currentBoard.id || '';
    },

    currentProjectId() {
      return this.$store.getters.getCurrentProjectId;
    },

    teamSlug() {
      return this.$store.getters.getTeamSlug;
    },
  },

  methods: {
    saveFiltersAsView() {
      const rawFilters = this.$store.getters.boardFilters(this.currentBoardId);
      const boardFilters = cloneDeep(rawFilters);

      boardFilters.include.boards = [this.currentBoardId];
      boardFilters.include.projects = [this.currentProjectId];

      if (boardFilters?.due_date?.before === '0') {
        delete boardFilters.due_date;
        boardFilters.has_due_date = false;
      }

      this.$store.dispatch('setViewEditMode', true);
      this.$store.dispatch('setSelectedViewType', 'card');
      this.$store.dispatch('setViewFilters', boardFilters);

      this.$router.push(`/${this.teamSlug}/newview`);
    },
  },
};
</script>

<style lang="scss">
.save-filters-button {
  @apply h-6
    ml-auto
    mr-0
    max-w-[65px]
    box-border
    bg-important-bg
    border
    border-solid
    border-important-border
    rounded-2xl
    flex
    items-center
    pl-[10px]
    pr-2
    gap-1
    text-text-default;

  &:hover {
    @apply bg-important-hover;
  }
}
</style>
